// extracted by mini-css-extract-plugin
export default {"reveal":"Reveal_reveal__wkFBZ","visible":"Reveal_visible__UusHO"};